export function parseResponseData(response) {
  return response.data;
}
